import { Component } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.scss'],
    standalone: false
})
export class SiteHeaderComponent {

  routerLinkOptions = {
    exact: true, fragment: 'exact', paths: 'subset',
    queryParams: 'exact'
  }
  constructor(public readonly authService: AuthService) { }

}
